import { EventChannel } from "../EventChannel/EventChannel";
var PAGE_TYPE_CHANNEL = new EventChannel();
var currentPageType = null;
export var setCurrentPage = function(pageType) {
    currentPageType = pageType;
    PAGE_TYPE_CHANNEL.trigger({
        pageType: pageType
    });
};
export var getCurrentPage = function() {
    return {
        pageType: currentPageType
    };
};
export var subscribeToCurrentPage = function(cb) {
    return PAGE_TYPE_CHANNEL.subscribe(cb);
};
export var unsubscribeFromCurrentPage = function(cb) {
    return PAGE_TYPE_CHANNEL.unsubscribe(cb);
};
export var clearCurrentPage = function() {
    currentPageType = null;
    PAGE_TYPE_CHANNEL.trigger({
        pageType: null
    });
};
